var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choices"},_vm._l((_vm.options),function(choice,idx){return _c('div',{key:idx,staticClass:"choice",on:{"click":function($event){return _vm.$emit('inputSelected', choice)}}},[_vm._v(_vm._s(choice.message)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }